import { DefaultService } from '@/services/DefaultService';

export default class TipoServicoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(ts) {
        return this._http.post(`${this._env}/promotor/tipodeservico`, ts, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/tipodeservico/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/tipodeservico/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    deleteForm(id) {
        return this._http
            .delete(`${this._env}/promotor/tipodeservico/form/${id}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    deleteEvent(id) {
        return this._http
            .delete(`${this._env}/promotor/tipodeservico/event/${id}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    deleteReasonPhoto(id) {
        return this._http
            .delete(`${this._env}/promotor/tipodeservico/reasonphoto/${id}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/tipodeservico.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(tiposervico) {
        return this._http
            .post(`${this._env}/promotor/tipodeservico/updatesituacao`, tiposervico, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
